import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import LoadingImage from '../Images/loading.gif';
import ErrorPage from './Errorpage';

const EPE = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const location = useLocation();
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
  
  useEffect(() => { 
    try {    
      window.history.pushState("you are being redirected...", "Redirect", "/redirect");
    } catch (err) {
      if (typeof console !== 'undefined') console.log(err);
    } 
    
    const queryParams = new URLSearchParams(location.search);
    const params = {};

    queryParams.forEach((value, key) => {
      params[key] = value;
    });

    console.log('Extracted Params:', params);

    fetchEPEURL(params);
  }, [location]);

  const fetchEPEURL = async (params) => {
    try {
      console.log('API Request Params:', params);
      const response = await axios.get(`${API_URL}/api/EPE/GetEPEUrl`, {
        params: {
          ...params
        }
      });
      
      setLoading(false);
      
      // Use direct navigation instead of form submission
      if (response.data && response.data.redirectUrl) {
        window.location.href = response.data.redirectUrl;
      } else {
        setError('EPE');
      }
    } catch (error) {
      console.error('Error fetching EPE URL:', error);
      setError('EPE');
      setLoading(false);
    }
  };

  return (
    <div>
      <table style={{backgroundColor: 'transparent'}} cellPadding="0" cellSpacing="0">
        <tbody>
          <tr style={{height: '30%'}}>
            <td></td>
          </tr>
          <tr>
            <td style={{width: '30%'}}></td>
            <td align="center" style={{fontSize: 'x-large'}}>
              {error && <ErrorPage errorType="EPE" />}
            </td>
            <td style={{width: '30%'}}></td>
          </tr>
          <tr>
            <td style={{width: '50%'}}></td>
            <td align="center" style={{fontSize: 'large'}}>
              {loading && (
                <img src={LoadingImage} id="loadinggif" style={{alignContent: 'center'}} alt="Loading" />
              )}
            </td>
            <td style={{width: '50%'}}></td>
          </tr>
          <tr>
            <td style={{width: '30%'}}></td>
            <td align="center">
              <div style={{fontSize: 'larger'}}></div>
            </td>
            <td style={{width: '30%'}}></td>
          </tr>
          <tr style={{height: '30%'}}>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default EPE;
